/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight.js';
// nm2024 themed components
import { TypographyNm2024  } from '../../../../nm2024Theme/components/typography/styles';
// styles
import {
  AnchorTabButtonStyled,
  BulletedListStyled,
  ColContentContainerStyled,
  ColNestedStyled,
  ColTabsContainerStyled,
  DivTabContentContainerStyled,
  LinkStyledButton,
  LinkStyledCta,
  RowNestedStyled,
  SectionContainerStyled,
  TabListStyled,
  TabPanelStyled,
  TabStyled,
} from './styles';

export default () => {
  return (
    <SectionContainerStyled
      id='home-products-overview'
      className='home-products-overview'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <AssistiveText component='h2'>
        Northwestern Mutual Primary Products
      </AssistiveText>
      <Tabs
        defaultIndex={0}
        className='reduced home-products-overview-tabs'
        forceRenderTabPanel>
        <Row>
          <ColTabsContainerStyled>
            <TabListStyled>
              <TabStyled className='home-products-overview-tabs-item'>
                <AnchorTabButtonStyled
                  className='nmx-tab-button nmx-tab-button__financial-planning'>
                  Financial Planning
                </AnchorTabButtonStyled>
              </TabStyled>
              <TabStyled className='home-products-overview-tabs-item'>
                <AnchorTabButtonStyled
                  className='nmx-tab-button'>
                  Insurance
                </AnchorTabButtonStyled>
              </TabStyled>
              <TabStyled className='home-products-overview-tabs-item'>
                <AnchorTabButtonStyled
                  className='nmx-tab-button'>
                  Investments
                </AnchorTabButtonStyled>
              </TabStyled>
            </TabListStyled>
          </ColTabsContainerStyled>
        </Row>
        <Row>
          <ColContentContainerStyled nested>
            <DivTabContentContainerStyled>
              {/* FINANCIAL PLANNING ////////////////////////////////////////////////////////// */}
              <TabPanelStyled className='react-tabs__tab-panel'>
                <RowNestedStyled align='center'>
                  <ColNestedStyled
                    medium={8}
                    itemScope
                    itemType='https://schema.org/FinancialProduct'>
                    <AssistiveText component='h3'>Northwestern Mutual Financial Planning Products</AssistiveText>
                    <meta
                      itemProp='name'
                      content='Northwestern Mutual Financial Planning Products'
                    />
                    <div itemProp='description'>
                      <TypographyNm2024 nextElement='typography'>
                        Here, better conversations can lead to better outcomes. Together, let&#39;s create a comprehensive plan that will:
                      </TypographyNm2024>
                      <BulletedListStyled
                        bulletedListData={[
                          { bulletText: 'Meet you where you are right now ' },
                          { bulletText: 'Include solutions designed for your specific goals and priorities' },
                          { bulletText: 'Be personalized to perform and evolve over time' },
                        ]}
                        bulletType='checkmark'
                      />
                    </div>
                    <LinkStyledButton
                      id='home-products-planning-cta'
                      variant='buttonLinkPrimary'
                      ariaLabel='Start planning with a financial professional'
                      linkUrl='/find-a-financial-advisor/'>
                      Let&#39;s start planning
                    </LinkStyledButton>
                    <LinkStyledCta
                      id='home-products-planning-fafa-cta'
                      variant='primaryDeemphasize'
                      endAdornment={CaratRight}
                      endAdornmentStylesReset
                      ariaLabel='Continue to Financial Planning'
                      linkUrl='/financial-planning/'>
                      Show me more
                    </LinkStyledCta>
                  </ColNestedStyled>
                </RowNestedStyled>
              </TabPanelStyled>
              {/* INSURANCE ////////////////////////////////////////////////////////// */}
              <TabPanelStyled className='react-tabs__tab-panel'>
                <RowNestedStyled align='center'>
                  <ColNestedStyled
                    medium={8}
                    itemScope
                    itemType='https://schema.org/FinancialProduct'>
                    <AssistiveText component='h3'>
                      Northwestern Mutual Insurance Products
                    </AssistiveText>
                    <meta
                      itemProp='name'
                      content='Northwestern Mutual Insurance Products'
                    />
                    <div itemProp='description'>
                      <TypographyNm2024 nextElement='typography'>
                        You&#39;ve built too much to let the unexpected knock you off course. Your financial advisor listens closely to what matters most and turns goals into guidance&#8212;including ways that can protect and give you more financial flexibility throughout your life. Let&#39;s look at how you can help:
                      </TypographyNm2024>
                      <BulletedListStyled
                        bulletedListData={[
                          { bulletText: 'Strengthen your plan with the right life insurance' },
                          { bulletText: 'Safeguard your income with disability insurance' },
                          { bulletText: (<>Be ready with a long&#45;term care plan that protects in more ways than one</>) },
                        ]}
                        bulletType='checkmark'
                      />
                    </div>
                    <LinkStyledButton
                      id='home-products-insurance-cta'
                      variant='buttonLinkPrimary'
                      ariaLabel='Continue with finding insurance'
                      linkUrl='/find-a-financial-advisor/'>
                      Get insurance
                    </LinkStyledButton>
                    <LinkStyledCta
                      id='home-products-insurance-fafa-cta'
                      variant='primaryDeemphasize'
                      endAdornment={CaratRight}
                      endAdornmentStylesReset
                      ariaLabel='Continue to Insurance'
                      linkUrl='/insurance/'>
                      Show me more
                    </LinkStyledCta>
                  </ColNestedStyled>
                </RowNestedStyled>
              </TabPanelStyled>
              {/* INVESTMENTS ////////////////////////////////////////////////////////// */}
              <TabPanelStyled className='react-tabs__tab-panel'>
                <RowNestedStyled align='center'>
                  <ColNestedStyled
                    medium={8}
                    itemScope
                    itemType='https://schema.org/FinancialProduct'>
                    <AssistiveText component='h3'>
                      Northwestern Mutual Investment Products
                    </AssistiveText>
                    <meta
                      itemProp='name'
                      content='Northwestern Mutual Investment Products'
                    />
                    <div itemProp='description'>
                      <TypographyNm2024 nextElement='typography'>
                        Get matched with a financial advisor who meets you right where you are and helps grow your money through better conversations. Let&#39;s pick only the best opportunities for you.
                      </TypographyNm2024>
                      <BulletedListStyled
                        bulletedListData={[
                          { bulletText: 'Investment advisory services' },
                          { bulletText: 'Brokerage accounts and services' },
                          { bulletText: 'Exclusive market commentary' },
                        ]}
                        bulletType='checkmark'
                      />
                    </div>
                    <LinkStyledButton
                      id='home-products-investments-cta'
                      variant='buttonLinkPrimary'
                      ariaLabel='Start investing with a financial professional'
                      linkUrl='/find-a-financial-advisor/'>
                      Let&#39;s start investing
                    </LinkStyledButton>
                    <LinkStyledCta
                      id='home-products-investments-fafa-cta'
                      variant='primaryDeemphasize'
                      endAdornment={CaratRight}
                      endAdornmentStylesReset
                      ariaLabel='Continue to Investments'
                      linkUrl='/investments/'>
                      Show me more
                    </LinkStyledCta>
                  </ColNestedStyled>
                </RowNestedStyled>
              </TabPanelStyled>
            </DivTabContentContainerStyled>
          </ColContentContainerStyled>
        </Row>
      </Tabs>
    </SectionContainerStyled>
  );
};
